// extracted by mini-css-extract-plugin
module.exports = {"inputText_container":"styles_inputText_container__2dwp5","inputBox":"styles_inputBox__2b6Yv"};